<template>
  <vs-row vs-type="flex">
    <vs-col
      vs-order="1"
      vs-type="flex"
      vs-justify="start"
      vs-align="center"
      vs-w="4"
      class="aisea-text-16-300-white"
    >
      現在地を設定
    </vs-col>
    <vs-col
      vs-order="2"
      vs-type="flex"
      vs-justify="flex-end"
      vs-align="center"
      vs-w="8"
    >
      <vx-tooltip
        :color="AISEA_COLOR.GRAY_BLACK"
        :text="tooltipText"
        position="top"
      >
        <vs-button
          class="ml-4 mt-4 mb-4 aisea-text-14-300-white"
          :color="AISEA_COLOR.BLUE"
          type="filled"
          @click="updateDefaultPosition"
          >現在地を設定</vs-button
        >
      </vx-tooltip>
    </vs-col>
  </vs-row>
</template>

<script>
/**
 * マップの初期値を設定するコンポーネント
 * @parent O.Settings
 * @props updateDefaultPosition: Function 初期位置のFireStoreとvuexのstoreを更新する関数
 */
import { ColorMixin } from "@/mixins";

export default {
  name: "M.PositionCard",
  mixins: [ColorMixin],
  props: {
    updateDefaultPosition: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      tooltipText:
        "現在表示中の緯度経度、ズーム値を初期表示地点として保存します",
      icon: require("@/assets/images/icons/sideber-menu/search.svg"),
    };
  },
};
</script>
